import { isTunnelPurchaseFlow } from "../../../common/utils/util";
import store from "../../../store/store";
import { StoreState } from "../../../store/store.interface";
import { getProductCountryCode } from "../../cart/shop-cart/store/shop-cart.selectors";
import { getBillingAddress } from "../../checkout/shop-checkout";

/**
 * @returns For tunnel flows, if the product country is US/CA
 * and the user billing address doesn't match the product country,
 * then we will use the school address to calculate the tax.
 */
export function isTaxCalculatedOnSchoolAddress(): boolean {
    const state = store.getState() as StoreState;
    const billingAddressCountry = getBillingAddress(state)?.country;
    const orderCountry = getProductCountryCode(state);
    
    if (!["US", "CA"].includes(orderCountry)) {
        return false;
    }
    return orderCountry !== billingAddressCountry;
}